<template>
  <div class="pad-admin-company">
    <div class="nav">
      <div class="title" @click="$router.replace({ path: '/' });">公司介绍</div>
    </div>
    <div class="content">
      <div class="left">
        <div class="left-item" @click="selectContent('company')" :class="{ active: active == 'company' }">
          <div class="left-item-icon icon-3"></div>
          <div class="left-item-title">公司介绍</div>
        </div>
        <div class="left-item" @click="selectContent('object')" :class="{ active: active == 'object' }">
          <div class="left-item-icon icon-4"></div>
          <div class="left-item-title">项目介绍</div>
        </div>
      </div>
      <div class="right">

        <div class="right-item" v-if="active == 'company' && shopInfo.company_info">
          <div v-for="(item, index) in shopInfo.company_info" :key="index" class="right-item-content">
            <div class="content-item" v-if="item.type == 'video/mp4'">
              <video :src="item.url" controls="controls"></video>
            </div>
            <div class="content-item" v-else>
              <img :src="item.url" alt="" />
            </div>
          </div>
        </div>

        <div class="right-item" v-if="active == 'object' && shopInfo.project_info">
          <div v-for="(item, index) in shopInfo.project_info" :key="index" class="right-item-content">
            <div class="content-item" v-if="item.type == 'video/mp4'">
              <video :src="item.url" controls="controls"></video>
            </div>
            <div class="content-item" v-else>
              <img :src="item.url" alt="" />
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import { getCompanyInfo } from "@api/index";

export default {
  name: 'pad-admin-company',
  data() {
    return {
      active: 'company',
      shopInfo : {},
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      let that = this;
      getCompanyInfo().then(res => {
        that.shopInfo = res.data;
      }).catch(err => {
        return that.$dialog.toast({ mes: err.msg || '请求异常' });
      })
    },
    selectContent(type) {
      this.active = type
    },
    goPage(page) {
      if (page == '/padAdmin/shop') return this.$dialog.toast({ mes: "暂未开放" });
      this.$router.push({
        path: page
      })
    }
  }
}
</script>

<style scoped  lang="scss">
 .pad-admin-company {

  .nav {
    font-family: 'YouSheBiaoTiHei';
    color: #FFFFFF;
    font-weight: 400;
    font-size: 48px;
    margin-top: 143px;
    margin-left: 30px;
    position: relative;

    .title {
      display: inline-block;
      padding: 0 44px 0;
    }

    &::before {
      content: '';
      width: 25px;
      height: 25px;
      border-top: 4px solid transparent;
      border-bottom: 4px solid #fff;
      border-right: 4px solid transparent;
      border-left: 4px solid #fff;
      ;
      /* 箭头的颜色 */
      position: absolute;
      /* 设置绝对定位 */
      top: 50%;
      left: 0%;
      transform: rotate(45deg) translateY(-50%);
    }
  }

  .content {
    display: flex;
    margin-top: 48px;

    .left {
      background: linear-gradient(180deg, #0066cc, transparent);
      width: 400px;
      height: 768px;
      border-radius: 0rem 20px 20px 20px;
      opacity: 0.9;
      display: flex;
      flex-wrap: wrap;
      align-content: center;


      .left-item {
        width: 100%;
        height: 108px;
        font-weight: 600;
        font-size: 30px;
        color: #FFFFFF;
        line-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 84px;

        .left-item-icon {
          width: 29px;
          height: 29px;
          background-size: 100%;

          &.icon-1 {
            background-image: url("../../assets/images/left-icon-1.png");
          }

          &.icon-2 {
            background-image: url("../../assets/images/left-icon-2.png");
          }

          &.icon-3 {
            background-image: url("../../assets/images/left-icon-3.png");
          }

          &.icon-4 {
            background-image: url("../../assets/images/left-icon-4.png");
          }

        }

        .left-item-title {
          margin-left: 19px;
        }

        &.active {
          background: #1FA4EB;
          border-radius: 0rem 20px 20px 0rem;
        }
      }
    }

    .right {
      background: linear-gradient(180deg, #0066cc, transparent);
      flex: 1;
      margin: 0 40px;
      height: 768px;
      border-radius: 20px;
      position: relative;
      overflow: scroll;

      .right-item-content {
        .content-item {
          img {
            width: 100%;
          }
          video {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
